export default {
  list: [],
  current_opportunity: {},
  funnel_values: {},
  loading: false,
};
